<template>
    <default-item class="thanksgiving_food_item--container" :item="item" :pricing-types="pricingTypes"
                  :layout="priceLayout"></default-item>
</template>

<script lang="ts">
/**
 * Custom component for Bimini food items.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2024-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2024-11-22 (1.0.0) (jhoward)
 *      - <panchoWilliesFoodItem> copied to <thanksgivingFoodItem>.
 *
 *    2025-04-08 (1.0.1) (jhoward)
 *      - Remove "visual_" prefix from class names in <thanksgivingFoodItem>.
 */

import {defineComponent, PropType} from "vue";
import {MenuItem} from "../defs";
import DefaultItem from "./defaultItem.vue";

export default defineComponent({
  name: 'thanksgiving-food-item',
  components: {
    DefaultItem
  },
  props: {
    item: {
      type: Object as PropType<MenuItem>,
      required: true
    },
    pricingTypes: {
      type: Array as PropType<string[]>,
      default: () => []
    },
    priceLayout: {
      type: String as PropType<'price-inline' | 'price-below'>,
      default: 'price-inline'
    }
  },
})
</script>

<style scoped>
.thanksgiving_food_item--container {
  text-align: center;
}

.thanksgiving_food_item--container:deep(.menu--item_title) {
  color: #b15731;
}
</style>